import {
    SovosAutocomplete,
    SovosBox,
    SovosCircularProgress,
    SovosCountryFlag,
    SovosTextField,
    SovosTypography,
} from "mosaic-react";
import React from "react";
import { getCountryLabel } from "./countryLabels";
import { AUTOCOMPLETE_POPPER_PROPS, FIELD_SPACING_SX } from "./constants";

const CountryAutocompleteField = ({
    contexts,
    disabled,
    i18n,
    loading,
    onChange,
    value,
}) => (
    <SovosBox sx={{ minHeight: 56, position: "relative", width: "100%", ...FIELD_SPACING_SX }}>
        <SovosAutocomplete
            disabled={disabled}
            fullWidth
            getOptionLabel={(option) => getCountryLabel(option?.country_code)}
            isOptionEqualToValue={(option, selected) =>
                option?.country_code === selected?.country_code
            }
            onChange={(_event, option) => onChange(option?.country_code || "")}
            options={contexts}
            {...AUTOCOMPLETE_POPPER_PROPS}
            renderInput={(params) => (
                <SovosTextField
                    {...params}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? (
                                    <SovosCircularProgress
                                        aria-label={i18n`Loading countries`}
                                        size="1.25rem"
                                    />
                                ) : null}
                                {params.InputProps?.endAdornment}
                            </>
                        ),
                    }}
                    label={i18n`Country`}
                    placeholder={i18n`Select country`}
                />
            )}
            renderOption={(props, option) => (
                <li {...props} key={option.country_code}>
                    <SovosBox sx={{ alignItems: "center", display: "flex", gap: 1 }}>
                        <SovosCountryFlag countryCode={option.country_code} flagHeight="20px" />
                        <SovosTypography variant="body2">
                            {getCountryLabel(option.country_code)}
                        </SovosTypography>
                    </SovosBox>
                </li>
            )}
            sx={{ mb: 0, "& .MuiOutlinedInput-root": { minHeight: 56 } }}
            value={contexts.find((context) => context.country_code === value) || null}
        />
    </SovosBox>
);

export default CountryAutocompleteField;
